import { RouterStore } from '@superwf/mobx-react-router';
import { createBrowserHistory } from 'history';
import { Provider } from 'mobx-react';
import * as React from 'react';
import { BrowserRouter, Route, Routes } from 'react-router';
import { ErrorProvider, MainContent, MainPage, RouterProvider } from 'telia-front-react';
import LoginNotice from './components/LoginNotice';
import ComponentErrorBoundary from './error/ComponentErrorBoundary';
import ErrorUtil from './error/ErrorUtil';
import PublicFooter from './footer/PublicFooter';
import BreadcrumbContainer from './header/BreadcrumbContainer';
import PublicHeader from './header/PublicHeader';
import RootStore from './stores/RootStore';
import MainWrapper from './wrapper/MainWrapper';
import TeliaLabelProvider from './wrapper/TeliaLabelProvider';
import TeliaThemeProvider from './wrapper/TeliaThemeProvider';
import TranslationsContextWrapper from './wrapper/TranslationsContextWrapper';
import ContentPage from './content/ContentPage';

const browserHistory = createBrowserHistory();

class App extends React.Component<InitialStateHolder> {
  private readonly rootStore: RootStore;

  constructor(initialStateHolder: InitialStateHolder) {
    super(initialStateHolder);
    const routerStore = new RouterStore(browserHistory);

    if (initialStateHolder.initialState == null) {
      const emptyInitialState: Partial<InitialState> = {};
      initialStateHolder = { initialState: emptyInitialState as InitialState };
    }

    if (initialStateHolder.initialState.serverContextPath) {
      routerStore.replace(initialStateHolder.initialState.serverContextPath);
    }

    this.rootStore = new RootStore(routerStore, initialStateHolder.initialState);
  }

  private logFrontendErrors(e: string) {
    const error: Error = new Error('Errors in frontend components');
    error.stack = e;
    ErrorUtil.pushErrorToTeliaRum(error);
  }

  public render() {
    return (
      <Provider {...this.rootStore}>
        <BrowserRouter>
          <ErrorProvider onError={this.logFrontendErrors}>
            <TranslationsContextWrapper initialLang={this.rootStore?.initialState?.currentLang} translations={this.rootStore?.initialState?.translations}>
              <RouterProvider navigate={this.rootStore.routeStore.navigate}>
                <TeliaThemeProvider>
                  <TeliaLabelProvider>
                    <MainWrapper>
                      <PublicHeader isMyTeliaUserAgent={this.props.initialState.isMyTeliaUserAgent} />
                      <ComponentErrorBoundary history={browserHistory}>
                        <MainPage>
                          <LoginNotice />
                          <BreadcrumbContainer />
                          <MainContent>
                            <Routes>
                              <Route path="/*" element={<ContentPage />} />
                            </Routes>
                          </MainContent>
                        </MainPage>
                      </ComponentErrorBoundary>
                      <PublicFooter isMyTeliaUserAgent={this.props.initialState.isMyTeliaUserAgent} />
                    </MainWrapper>
                  </TeliaLabelProvider>
                </TeliaThemeProvider>
              </RouterProvider>
            </TranslationsContextWrapper>
          </ErrorProvider>
        </BrowserRouter>
      </Provider>
    );
  }
}

export default App;
